<template>
  <div v-if="links.length > 3">
    <div class="flex flex-wrap justify-center -mb-1 mt-7">
      <template v-for="(link, key) in links" :key="key">
        <Link v-if="link.url!=null" class="px-4 py-3 mb-1 mr-1 leading-4 rounded hover:bg-yellow" :class="{ 'bg-enriqueto_green text-white': link.active }" :href="link.url+'#paginated'" v-html="link.label" />
      </template>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
export default {
    props: {
        links: Array,
    },
    components: {Link}
}
</script>